import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M12.168 12.64a1.333 1.333 0 1 1 2.667 0v8a1.333 1.333 0 1 1-2.667 0zm1.333-6.572a1.333 1.333 0 1 0 0 2.666 1.333 1.333 0 0 0 0-2.666" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M13.501.667C6.137.667.168 6.636.168 14s5.97 13.333 13.333 13.333S26.835 21.363 26.835 14 20.865.667 13.5.667ZM2.835 14a10.667 10.667 0 1 0 21.333 0 10.667 10.667 0 0 0-21.333 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }